<template>
  <div class="product_list_container">
    <el-form inline @submit.native.prevent class="product_list_form">
      <label
        class="el-form-item__label cell"
        style="font-size: 14px;font-weight: 900; line-height: 30px"
      >
        {{ $t('homePage.productInquire') }}
      </label>
      <el-form-item label="" prop="keys">
        <el-input
          v-model="form.keys"
          :placeholder="$t('homePage.enterProductModel')"
          @keyup.enter.native="searchForm"
          style="width: 260px;"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="searchForm()" type="primary" size="small">{{ $t('homePage.search') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetForm" class="operate-btn" size="small">{{ $t('homePage.reset') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="advancedSearchChange" class="operate-btn" size="small">
          {{ $t('homePage.advancedSearch') }}<i :class="advancedSearchIcon" style="line-height:0px" />
        </el-button>
      </el-form-item>
    </el-form>
    <el-form
      inline
      v-if="advancedSearchStatus"
      style="text-align: left;height:33px; margin-bottom:15px;"
    >
      <el-form-item prop="productLine" :model="form">
        <el-select
          v-model="form.productLine"
          filterable
          clearable
          remote
          :remote-method="getProdLineListBydebounce"
          :placeholder="$t('homePage.clickProductLine')"
          :loading="loading"
          value-key="lineId"
          @change="onProdLineChange"
          @clear="clearLine"
        >
          <el-option
            v-for="item in allProdLines"
            :key="item.lineId"
            :label="item.lineName"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="productCategories">
        <el-select
          v-model="form.productCategories"
          filterable
          clearable
          remote
          :remote-method="getProductCategoriesBydebounce"
          reserve-keyword
          :placeholder="$t('homePage.clickProductCategories')"
          :loading="loading"
          value-key="categoryId"
          @change="onProductCategoriesChange"
          @clear="clearCategories"
          style="width: 260px;"
        >
          <el-option
            v-for="item in allProductCategories"
            :key="item.categoryId"
            :label="item.categoryName"
            :value="item"
          >
            <span style="font-weight: bold">{{ `[${$t('addConfigModule.productCategory')}]：` + item.categoryName }}</span>
            <span style="padding-left: 34px">{{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="productSeries">
        <el-select
          v-model="form.productSeries"
          filterable
          clearable
          remote
          :remote-method="getProductSeriesListBydebounce"
          reserve-keyword
          :placeholder="$t('homePage.clickProductSeries')"
          :loading="loading"
          value-key="seriesId"
          @change="onProductSeriesChange"
          @clear="clearSeries"
        >
          <el-option
            v-for="item in allProductSeries"
            :key="item.seriesId"
            :label="item.seriesName"
            :value="item"
          >
            <!--产品系列-->
            <span style="font-weight: bold">{{ `[${$t('addConfigModule.productRange')}]：` + item.seriesName }}</span>
            <span style="padding-left: 34px">{{ `[${$t('addConfigModule.productCategory')}]：` + item.categoryName }}</span>
            <span style="padding-left: 34px">{{ `[${$t('addConfigModule.productLine')}]` + item.lineName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="showHost">
        <el-checkbox
          v-model="form.showHost"
          true-label="true"
          false-label="false"
          @change="searchForm"
        >
          {{ $t('homePage.accordingHost') }}
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div class="table" v-if="showProductList">
      <el-table
        show-header
        :data="ProductInitListVO"
        ref="table"
        :border="true"
        :stripe="true"
        style="width: 100%"
        :cell-style="changeStyle"
        v-loading="seachProductLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266','text-align': 'left'}"
      >
        <el-table-column
          prop="productName"
          :label="$t('homePage.productModel')"
          min-width="15%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductNameFormation :scope="scope" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('exportExcelModule.productDes')"
          :render-header="foo"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <long-text
              :text="scope.row.productDesc"
              :switch-flg="switchFlgP"
            />
          </template>
        </el-table-column>

        <el-table-column
          prop="productPrice"
          :label="$t('addConfigModule.price')"
          width="120"
          align="right"
          :formatter="priceFormat"
        >
          <!--增加价格高亮展示 mzy 2021年4月28日13:36:39-->
          <template slot-scope="scope">
            {{ priceFormat(scope.row,scope.column,scope.row.productPrice) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isPartner "
          prop="promotionPrice"
          :label="$t('addConfigModule.promotionPrice')"
          width="120"
          align="right"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isDiscount">{{ productPriceFormat(null,null,scope.row.promotionPrice) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="spdcPrice"
          :label="$t('addConfigModule.serviceProviderPrice')"
          width="200"
          align="right"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isSpdc == 1 && (isPartner && getStore('partnerAuth')=='1' || !isPartner)">{{ productPriceFormat(null,null,scope.row.spdcPrice) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productStatusStr"
          :label="$t('addConfigModule.status')"
          min-width="7%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductStatusFomation :scope="scope.row" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.totalPage"
      />
    </div>
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import api from '../../api';
import eventBus from '@/utils/eventBus';
import {
  notesTextFormat,
  isPartnerM,
  getStore
} from '@/utils/mUtils';
import { productPriceFormat, changeStyle } from '../../utils/numberFormater';
import ProductNameFormation from '../components/ProductNameFormation';
import longText from '../quotationlist/longText';
import ProductStatusFomation from '../components/ProductStatusFomation';
export default {
  name: 'ProductList',
  data () {
    return {
      seachProductLoading: false,
      showProductList: false,
      loading: false,
      isPartner: true,
      switchFlgP: true,
      form: {
        productLine: '',
        productCategories: '',
        productSeries: '',
        keys: '',
        showHost: 'false',
        showService: 'false'
      },
      pagination: {
        currentPage: 1,
        totalPage: 0,
        pageSize: 10
      },
      allProdLines: [],
      allProductCategories: [],
      allProductSeries: [],
      selectCount: 30,
      ProductInitListVO: [],
      advancedSearchStatus: false,
      advancedSearchIcon: 'el-icon-caret-bottom'
    };
  },
  components: {
    ProductStatusFomation,
    ProductNameFormation,
    longText
  },
  methods: {
    getStore,
    changeStyle,
    notesTextFormat,
    productPriceFormat,
    advancedSearchChange () {
      if (this.advancedSearchStatus === false) {
        this.advancedSearchStatus = true;
        this.advancedSearchIcon = 'el-icon-caret-top';
        this.getProdLineList();
        this.getProductCategories();
        this.getProductSeriesList();
      } else {
        this.advancedSearchStatus = false;
        this.advancedSearchIcon = 'el-icon-caret-bottom';
      }
    },
    // 下一页
    handleCurrentChange () {
      this.searchForm();
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProdLineListBydebounce: XEUtils.debounce(
      function (lineName) {
        this.getProdLineList(lineName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品线下拉列表
    getProdLineList (lineName) {
      api.getProductLineList({
        params: {
          userCollection: '',
          groupType: 1,
          lineName,
          pageSize: this.selectCount
        }
      }).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.allProdLines = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(`${this.$t('homePage.networkAnomaly')}`);
      });
    },
    // 选择产品线改变事件
    onProdLineChange () {
      // 清空产品大类、系列
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.getProductCategories();
      // 产品系列
      this.allProductSeries = [];
      this.form.form = '';
      this.getProductSeriesList();
      this.searchForm();
    },
    // 清空产品线同时清空产品大类，产品系列
    clearLine () {
      // 产品大类
      this.allProductCategories = [];
      this.form.productCategories = '';
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProductCategoriesBydebounce: XEUtils.debounce(
      function (categoryName) {
        this.getProductCategories(categoryName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品大类下拉列表
    getProductCategories (categoryName) {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          userCollection: '',
          groupType: 1,
          categoryName,
          pageSize: this.selectCount
        }
      };
      api.getProductCategoriesList(param).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.allProductCategories = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(`${this.$t('homePage.networkAnomaly')}`);
      });
    },
    // 清空产品大类，同时清空产品系列
    clearCategories () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.form.productSeries = '';
      this.onProdLineChange();
    },
    // 选择产品大类改变事件
    onProductCategoriesChange () {
      // 清空产品系列选中值
      this.form.productSeries = '';
      this.searchForm();
      this.getProductSeriesList();
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProductSeriesListBydebounce: XEUtils.debounce(
      function (seriesName) {
        this.getProductSeriesList(seriesName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品系列列表
    getProductSeriesList (seriesName) {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          categoryId: this.form.productCategories.categoryId,
          userCollection: '',
          groupType: 1,
          seriesName,
          pageSize: this.selectCount
        }
      };
      api.getProductSeriesList(param).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.allProductSeries = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(`${this.$t('homePage.networkAnomaly')}`);
      });
    },
    onProductSeriesChange () {
      this.searchForm();
    },
    clearSeries () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.onProductCategoriesChange();
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    searchFormBydebounce: XEUtils.debounce(
      function () {
        this.searchForm();
      },
      200,
      { leading: false, trailing: true }
    ),
    // 搜索功能
    searchForm () {
      this.isPartner = isPartnerM();
      let { productLine, productCategories, productSeries, keys, showHost, showService } = this.form;
      if ((productLine == null || productLine === '') &&
            (productCategories == null || productCategories === '') &&
            (productSeries == null || productSeries === '') &&
            (keys == null || keys.trim().length === 0) &&
            showHost === 'false' &&
            showService === 'false'
      ) {
        this.ProductInitListVO = [];
        this.showProductList = false;
        return;
      }
      this.showProductList = true;
      this.page = 1;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length === 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let param = {
          lineId: this.form.productLine !== '' ? this.form.productLine.lineId : '',
          categoryId: this.form.productCategories !== '' ? this.form.productCategories.categoryId : '',
          seriesId: this.form.productSeries !== '' ? this.form.productSeries.seriesId : '',
          propertyCode: propertyCode,
          fieldFatherID: fieldFatherID,
          keys: this.form.keys,
          showHost: this.form.showHost,
          showService: this.form.showService,
          showHostAndOpticalModule: this.form.showHostAndOpticalModule,
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          isServiceFlag: false
      };
      this.seachProductLoading = true;
      api.queryProduct(param).then(res => {
        this.seachProductLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.ProductInitListVO = json.data.list;
          if (json.data.total > 50) {
            // 最多显示50条
            this.pagination.totalPage = 50;
          } else {
            this.pagination.totalPage = json.data.total;
          }
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.seachProductLoading = false;
        this.$notify.error('查询产品失败！');
      });
    },

    // 重置搜索框
    resetForm () {
      this.showProductList = false;
      // 重置产品线
      // this.allProdLines = []
      // 重置产品大类列表数据
      // this.allProductCategories = [];
      // 重置产品系列列表数据
      // this.allProductSeries = [];
      this.form.productLine = '';
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.form.keys = '';
      this.form.showHost="false";
      this.ProductInitListVO = [];
      this.pagination.totalPage = 0;
    },
    foo (h, { column }) {
      if (column.label) {
        return h('span', {}, [
          h('span', [column.label]),
          h(
            'button',
            {
              attrs: {
                style:
                  'float:right;color:#3fbbdc;border:none;border-radius:5px;height:2rem'
              },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            },
            [`${this.$t('productAdded.expandOrCloseAll')}`]
          )
        ]);
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    priceFormat (row, column, cellValue) {
      if (row.isRiil && row.retailPriceFloatingRate > 0) {
        if (row.retailPriceFloatingRate > 0) {
          return 'list*' + row.retailPriceFloatingRate;
        }
      }
      if (row.lineId == 25) {
        if (row.productPrice < 1 || row.productPrice == null) {
          if (row.sprPriceRatio !== null) {
            return row.sprPriceRatio;
          } else {
            return row.productPrice;
          }
        }
      }
      return this.formatePrice(cellValue);
    },
    formatePrice (cellValue) {
      if (cellValue === 0) {
        return 0;
      }
      if (cellValue) {
        let value = Number(cellValue).toFixed(2);
        let intPart = Math.trunc(value);
        let intPartFormat = intPart
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        let value2Array = value.toString().split('.');
        if (value2Array.length === 2) {
          let floatPart = value2Array[1]; // 拿到小数部分
          intPartFormat = intPartFormat + '.' + floatPart;
          return intPartFormat;
        } else {
          return intPartFormat;
        }
      }
    }
  },
  mounted () {
    this.getProdLineList();
    this.getProductCategories();
    this.getProductSeriesList();
  }
};
</script>

<style lang="scss" scoped>
.product_list_container{
  ::v-deep .el-table__body tr:hover > td{
    background-color:#FFFFFF !important;
  }
  ::v-deep .el-select{
      width: 260px;
  }
  .operate-btn:hover {
    background-color: #fff !important;
  }
  ::v-deep .el-input__inner{
    height: 3.2rem;
    line-height: 3.2rem;
  }
  .product_list_form{
    text-align: left;
    height:33px;
    margin-bottom: 15px;
  }

}

</style>
